import { Injectable } from '@angular/core';
import { BaseService } from '../../shared/services/base.service';
import { BookingUrl } from '../../shared/urls/booking.url';

@Injectable()

export class BookingService {
    constructor(public baseService: BaseService) {}

    getBookingCache() {
        const url = BookingUrl.GET_BOOKING_CACHE;
        return this.baseService.getData(url);
    }
    
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/booking/booking.service.ts